import { useEffect, useLayoutEffect, useRef, useState } from "react";

const COMPACT_HEADER_HEIGHT = 56;

export const useTaskViewerHeaderLayout = (collapseProgress: number) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const collapseProgressRef = useRef(collapseProgress);
  const [expandedHeight, setExpandedHeight] = useState<number>();

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;

    const updateExpandedHeight = () => {
      if (collapseProgressRef.current <= 0) {
        setExpandedHeight(header.scrollHeight);
      }
    };
    updateExpandedHeight();

    const resizeObserver = new ResizeObserver(updateExpandedHeight);
    resizeObserver.observe(header);
    return () => resizeObserver.disconnect();
  }, []);

  useLayoutEffect(() => {
    collapseProgressRef.current = collapseProgress;
    const header = headerRef.current;
    if (!header) return;

    if (collapseProgress <= 0) {
      header.style.removeProperty("--header-collapse-progress");
      header.style.removeProperty("--header-height");
      return;
    }

    header.style.setProperty(
      "--header-collapse-progress",
      collapseProgress.toString()
    );
    if (expandedHeight) {
      const height =
        COMPACT_HEADER_HEIGHT +
        (expandedHeight - COMPACT_HEADER_HEIGHT) * (1 - collapseProgress);
      header.style.setProperty("--header-height", `${height}px`);
    }
  }, [collapseProgress, expandedHeight]);

  return headerRef;
};
